import { render, staticRenderFns } from "./CyberboardNovel2.vue?vue&type=template&id=2b91f348&scoped=true"
import script from "./CyberboardNovel2.vue?vue&type=script&lang=ts"
export * from "./CyberboardNovel2.vue?vue&type=script&lang=ts"
import style0 from "./CyberboardNovel2.vue?vue&type=style&index=0&id=2b91f348&prod&lang=scss&scoped=true"
import style1 from "./CyberboardNovel2.vue?vue&type=style&index=1&id=2b91f348&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b91f348",
  null
  
)

export default component.exports